@let businessCardPreview = this.businessCardPreview();
@let params = this.params();

@if (businessCardPreview) {
    <div class="background-wrapper-for-shadow">
        <div class="background" [style.background-image]="'url(' + businessCardPreview.mainImageUrl + ')'">
            <div class="left-info-card">
                <div class="left-card-content">
                    <div class="logo" [style.background-image]="'url(' + businessCardPreview.logoUrl + ')'"></div>
                    <div class="company-name">{{ businessCardPreview.companyName }}</div>
                    <div class="company-address">
                        <div>{{ businessCardPreview.streetAndNumber }},</div>
                        <div>{{ businessCardPreview.postalCodeAndCity }}</div>
                    </div>
                    <div class="phone">{{ 'COMPANY_SEARCH.TEL' | translate }}: {{ businessCardPreview.phone }}</div>
                    <div class="email">{{ 'COMPANY_SEARCH.EMAIL' | translate }}: {{ businessCardPreview.email }}</div>
                    <div class="separator-line"></div>
                    <warema-business-card-opening-times [openingTimes]="businessCardPreview.openingTimes" />
                </div>
            </div>
            @if (businessCardPreview.badges.length > 0) {
                <warema-business-card-badges [badges]="businessCardPreview.badges" />
            }
            <div class="qr-code-container">
                <warema-qr-code
                    [data]="businessCardPreview.urlCityNameNo | businessCardUrlWithParams: params"
                    [width]="98"
                />
            </div>
        </div>
    </div>
    <warema-button
        class="print-btn"
        id="print-btn"
        [iconRight]="'print'"
        [text]="'COMPANY_SEARCH.PRINT' | translate"
        (click)="popupResult$.next(true)"
    />
}
